module.exports = __webpack_public_path__ + "static/media/5.029f2982.png";